import axios from "axios";
import { AUTH_CHALLENGE_API, AUTO_SEND_TRANSACTION_API, GOLD_DATA_SOURCE_API } from "../../../constants/api";

export default function GetAuthChallenge(){
    const api =`${AUTH_CHALLENGE_API}`;
    return axios.get(api);
}
